//============================================================================
// Name        : ls_sync.ts
// Purpose     : Implement handling LS data sync
// Created     : 2020-12-27
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";
import { IChannelData, LsSyncBase } from "./ls_sync_base";

// declare const lsCheckAccessUrl: string;
declare const lsSyncPreviewUrl: string;
declare const lsSyncUrl: string;
declare const backUpStatus: string;

export class LsSync extends LsSyncBase {
    constructor() {
        super("syncDialog");
    }

    show(): void {
        this.connectLScable(this.dialogId, (data: IChannelData) => {
            console.log(data);
            const successFinalUpdate    = "Synchronization complete";
            const successV2Update       = "Synchronization Started";
            const errorFinalUpdate      = "Error pushing data to Lightspeed";
            // const successLsCredentials  = "LS credentials are fine";
            // const errorLsCredentials    = "LS credentials has some problems";

            if (data.message.toLowerCase().includes("error")) {
                this.syncDialogDoSyncButton.prop("disabled", true);
            }

            // if (data.message == successLsCredentials || data.message == errorLsCredentials) {
            //     if (data.inProgress && data.success) {
            //         $(".checkLSAccessStatus").hide();
            //         LsSync.UpdateCheckLSAccessStatus(this.dialogId, data.message, data.inProgress, data.success);
            //         this.syncStartToContinue();
            //     } else if (!data.inProgress && !data.success) {
            //         LsSync.UpdateCheckLSAccessStatus(this.dialogId, data.message, data.inProgress, data.success);
            //         $("#syncLsCredentialsDialog").modal("show");
            //     }
            // } else
            if (data.message == successFinalUpdate || data.message == errorFinalUpdate) {
                console.log('successFinalUpdate');
                LsSync.UpdateFinalStatus(data.message, data.inProgress, data.success);
                if (data.success) {
                    this.showRefreshBtn();
                }
            } else if (data.message == successV2Update) {
                // console.log('run syncStartedV2');
                this.syncStartedV2();
                LsSync.UpdateFinalStatus(data.message, false, true);
                this.showRefreshBtn();
            } else {
                if ($(".finalStatus").is(":visible")) {
                    LsSync.UpdateFinalStatus( data.message, data.inProgress, data.success);
                    if (!data.inProgress) {
                        this.disconnect();
                        if (data.success) {
                            this.showRefreshBtn();
                        }
                    }
                } else {
                    $(".sync-actions").hide();
                    LsSync.UpdateCurrentStatus(this.dialogId, data.message, data.inProgress, data.success);
                    if (!data.inProgress && data.success) {
                        $(".sync_statusTitle").hide();
                        $(".sync-actions").show();
                    }
                }
            }
        });

        // this.syncDialogCheckLsAccessButton.off("click");
        // this.syncDialogCheckLsAccessButton.on("click", () => { this.checkLSAccess(); });
        this.syncDialogContinueButton.off("click");
        this.syncDialogContinueButton.on("click", () => { this.syncContinue(); });
        this.syncDialogDoSyncButton.off("click");
        this.syncDialogDoSyncButton.on("click",   () => { this.doSync(); });
        this.syncDialogContinueButton.show();
        $(".sync-actions").hide();
        // $(".continue-actions").hide();
        // $(".checkLSAccessStatus").hide();
        $(".currentStatus").hide();
        $(".finalStatus").hide();
        $("#syncDialog").modal("show");
    }

    syncStartedV2() {
        $(".finalStatus").show();
        this.syncDialogContinueButton.hide();
        $(".sync-actions").show();
    }

    // syncStartToContinue() {
    //     $(".checkLSAccessStatus").delay(5000).fadeOut("slow");
    //     $(".continue-actions").show();
    //     setTimeout(() => { this.syncDialogContinueButton.click(); }, 100);
    // }

    // async checkLSAccess() {
    //     this.syncDialogCheckLsAccessButton.hide();
    //     $(".checkLSAccessStatus").show();
    //
    //     const resp = await axios.get(lsCheckAccessUrl);
    //     if (resp.status != 200) {
    //         window.showErrorDialog("something went wrong, try again later.");
    //         return;
    //     }
    // }

    async syncContinue() {
        this.syncDialogContinueButton.hide();
        $(".sync-actions").show();
        $(".currentStatus").show();
        const reDownloadLsInv = this.syncDialogReDownloadCheckBox.is(":checked");
        const resp = await axios.get(lsSyncPreviewUrl, { params: { re_download_ls_inv: reDownloadLsInv } });

        if (resp.status != 200) {
            window.showErrorDialog("Generating synchronization preview.");
            return;
        }
    }

    async doSync() {
        this.syncDialogDoSyncButton.prop("disabled", true);
        $(".finalStatus").show();
        LsSyncBase.UpdateFinalStatus("Starting Synchronization...", true, false);

        const resp = await axios.get(lsSyncUrl, { params: { backup_status: backUpStatus } });
        if (resp.status != 200) {
            window.showErrorDialog(resp.data.message);
            return;
        }
    }
}
